export default {"src":"/_next/static/media/loader.dc52ea5b.gif","height":64,"width":64,"blurWidth":0,"blurHeight":0};